import React from 'react';

export default class Page6 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">
                                            <div className="lightgreencontentbg keyquestionpad">

                                                <div className="uiheading paratop"><p>The statistics of bad
                                                    health are clear, very clear. We spend our lives being
                                                    paranoid about death, murder, homicide, you name it; it’s on
                                                    the front page of every paper…… Fact: Dietrelated disease is
                                                    the biggest killer in the United States, right now, here
                                                    today. This is a global problem. It’s a catastrophe. It’s
                                                    sweeping the world. England is right behind you, as usual.
                                                    (Laughter) I know they were close, but not that close. We
                                                    need a revolution. Mexico, Australia, Germany, India, China,
                                                    all have massive problems of obesity and bad health. Think
                                                    about smoking. It costs way less than obesity now. Obesity
                                                    costs you Americans 10 percent of your healthcare bills, 150
                                                    billion dollars a year. In 10 years, it’s set to double: 300
                                                    billion dollars a year. And let’s be honest guys, you ain’t
                                                    got that cash. (Laughter) I came here to start a food
                                                    revolution that I so profoundly believe in. We need it. The
                                                    time is now. We’re in a tipping-point moment….'</p></div>

                                            </div>
                                            <div className="border_subtitle">Jamie used the following tactics to
                                                influence his audience:
                                            </div>

                                            <ol className="brownbullet-list listcontentSpacing tableliclass1 sept">
                                                <li><p><span
                                                    className="subtiltereg subtiltpad sept">Attention –</span> Jamie
                                                    starts by grabbing everyone’s attention with a strong
                                                    emotive statement.</p></li>
                                                <li><p><span
                                                    className="subtiltereg subtiltpad sept">Rapport –</span> his
                                                    humour and down-to-earth style help him connect with the
                                                    audience. They listen to what he has to say because they
                                                    like him. </p></li>
                                                <li><p><span
                                                    className="subtiltereg subtiltpad sept">Empathy – </span>he
                                                    appeals to the issues that matter to the audience most.</p>
                                                </li>
                                                <li><p><span
                                                    className="subtiltereg subtiltpad sept">Common Goals –</span> he
                                                    emphasises how we all share the same challenges to encourage
                                                    a collective spirit.</p></li>
                                                <li><p><span
                                                    className="subtiltereg subtiltpad sept"> Importance – </span>he
                                                    spells out the cost and significance of the problem.</p>
                                                </li>
                                                <li><p><span
                                                    className="subtiltereg subtiltpad sept">Reason –</span> he
                                                    uses hard data to validate his points.</p></li>
                                                <li><p><span
                                                    className="subtiltereg subtiltpad sept">Assertion – </span>he
                                                    passionately urges action now.</p></li>
                                                <li><p><span
                                                    className="subtiltereg subtiltpad sept">Persistence –</span> this
                                                    speech comes after a seven-year tireless campaign that
                                                    continues to this day.</p></li>
                                            </ol>
                                            <div className="paratop">
                                                <p>This carefully crafted speech aims to maximise the power of
                                                    influence by utilising a wide range of tactics that will
                                                    appeal to a variety of listeners.</p>
                                            </div>
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">Now take the following steps:
                                                </div>

                                                <ol className="brownbullet-list listcontentSpacing list-bottom-emptypad tableliclass1">
                                                    <li><p className="subtiltpad"> Spend a few minutes reading
                                                        this account again and ask yourself what you can learn
                                                        from it.</p></li>
                                                    <li><p className="subtiltpad">Think of a time when you tried
                                                        to persuade others to support your idea, perhaps
                                                        starting a revolution of your own!</p></li>
                                                    <li><p className="subtiltpad"> Note down what influencing
                                                        behaviours you demonstrated.</p></li>
                                                    <li><p className="subtiltpad"> How effective were your
                                                        skills; did it make others change their minds, or even
                                                        more importantly, change their behaviour?</p></li>
                                                    <li><p className="subtiltpad"> How many people did you get
                                                        to join your ‘Food Revolution’ because they understood
                                                        the consequences of not doing so?</p></li>
                                                    <li>
                                                        <div className="uiheading"><p
                                                            className="subtiltpad"> What did you learn from that
                                                            experience, to ensure you get the required outcome
                                                            next time? What alternative strategies would you
                                                            use?</p></div>
                                                    </li>

                                                </ol>
                                            </div>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page7')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}